import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  OnDestroy,
  ChangeDetectorRef,
  Input,
  AfterViewInit,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { CustomerModel } from "src/app/models/customer.model";
import { AddressService } from "src/app/services/address.service";
import { CustomersService } from "src/app/services/customer.service";
import { AddressDialogComponent } from "../../address-dialog/address-dialog.component";
import { ReferralService } from "src/app/services/referral.service";
import { ToastrService } from 'ngx-toastr';


// // Material
// import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// // RxJS
// import { Subscription, Observable } from 'rxjs';
// import { map, startWith } from 'rxjs/operators';
// // Services and Models
// import { CustomerModel, CustomersService } from '';
// import { AuthService } from '../../../../../core/auth';
// import { AddressService } from '../../../../../core/_base/crud';
// import { CustomDatePipe } from '../../../../../core/_base/layout/index'
// import { AddressDialogComponent } from '../address-dialog/address-dialog.component';
// import { MyreferralsService } from '../../../../../core/myreferrals/myreferrals.service'

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  // @Input() element: any;
  customer: CustomerModel;
  newcustomerForm: FormGroup;
  hasFormErrors: boolean = false;
  countryList = [];
  stateList = [];
  cityList = [];
  localityList = [];
  sourceList = [];
  stageList = [];
  typeList = [];
  parentCustomerList = [];
  territoryList = [];
  filteredOptions: Observable<string[]>;
  tagList = [];
  designationList: any = [];
  customFields = [];
  option = [];
  frontViewRemove: boolean = false;
  backViewRemove: boolean = false;
  viewLoading: boolean = false;
  isCustomer: boolean = true;
  sameMobileNo: string;
  currentUser: any;
  sameEmail: string;
  private componentSubscriptions: Subscription;
  data1: string;
  referralList: any;
  referralListArray: [];
  businessData: any;
  ReferredBy: any;
  CountryId: any
  StateId: any
  CityId: any
  buttonShow: boolean = true;
  userData: any;
  filterCountryList = [];
  filterStateList = [];
  filterCityList = [];
  filterLocalityList = [];
  @Input() customerId: number;
	@Input() referralListdata: any[];
	@Input() referByCode: string;
  
  constructor(
    // public dialogRef: MatDialogRef<CustomerEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private referralService: ReferralService,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private addService: AddressService,
    private customersService: CustomersService,
    // private customDatePipe: CustomDatePipe,
    private dialog: MatDialog,
    // private myreferralsService: MyreferralsService,
    private addressService: AddressService
  ) { 
    this.newcustomerForm = this.fb.group({
      LeadName: [''],
      RefNo: [''],
      PersonName: [''],
      MobileNo: [''],
      ContactNo: [''],
      Email: [''],
      PersonDesignation: [''],
      Address: [''],
      CountryName: [''],
      StateName: [''],
      CityName: [''],
      LocalityName: [''],
      PinCode: ['']
    });
  }
  

  ngOnInit() {
    // this.createForm();
    // this.getCountryList();
    // this.getSourceList();
    console.log(this.data)
    this.customersService.getCustomerDetails(this.customerId).subscribe(res => {
      if (res) {
        this.userData = res; // Assign `res` directly since it has the data
        console.log(res)
        this.newcustomerForm.patchValue({
          LeadName: this.userData.LeadName || '',
          RefNo: this.userData.RefNo || '',
          PersonName: this.userData.PersonName || '',
          MobileNo: this.userData.MobileNo || '',
          ContactNo: this.userData.ContactNo || '',
          Email: this.userData.Email || '',
          PersonDesignation: this.userData.PersonDesignation || '',
          Address: this.userData.Address || '',
          CountryName: this.userData.CountryName || null,
          StateName: this.userData.StateName || null,
          CityName: this.userData.CityName || null,
          LocalityName: this.userData.LocalityName || null,
          PinCode: this.userData.PinCode || '',
        });
      } else {
        console.error("Received undefined response from API");
      }
    })
  }

}
